import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, IconButton, TextField, Grid, Typography, Box
} from '@mui/material';

function ReceiptDialogEditNotes({ isOpen, onClose, receipt, onSave }) {
    const [notes, setNotes] = useState("");

    useEffect(() => {
        if (isOpen && receipt) {
            setNotes(receipt.notes || "");
        }
    }, [isOpen, receipt]);

    const handleSave = () => {
        onSave(receipt.id, { notes: notes });
        onClose();
    };

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: '20px',
                    padding: '8px',
                    minWidth: 400
                }
            }}
        >
            {/* Creative Header - Matching the Costs Dialog */}
            <DialogTitle sx={{
                p: 3,
                textAlign: 'center',
                background: 'linear-gradient(135deg, #151269 0%, #352fcc 100%)',
                color: 'white',
                borderRadius: '15px 15px 5px 5px',
                position: 'relative'
            }}>
                <Typography variant="h6" sx={{ fontWeight: 700, letterSpacing: '1px' }}>
                    RECEIPT NOTES
                </Typography>
                <Typography variant="caption" sx={{ opacity: 0.8 }}>
                    Add context, descriptions, or reminders
                </Typography>
            </DialogTitle>

            <IconButton
                onClick={onClose}
                sx={{ position: 'absolute', right: 16, top: 16, color: 'white' }}
            >
                <i className="icon-cross" style={{ fontSize: '18px' }} />
            </IconButton>

            <DialogContent sx={{ mt: 3 }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box sx={{
                            p: 2,
                            bgcolor: '#f8f9fa',
                            borderRadius: '12px',
                            border: '1px solid #e0e0e0',
                            transition: 'border-color 0.3s',
                            '&:focus-within': {
                                borderColor: '#151269'
                            }
                        }}>
                            <Typography variant="overline" color="textSecondary" sx={{ fontWeight: 'bold' }}>
                                Details & Descriptions
                            </Typography>
                            <TextField
                                fullWidth
                                multiline
                                rows={6}
                                variant="standard"
                                placeholder="What was this for? e.g. Lunch with client, Office supplies..."
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                                InputProps={{
                                    disableUnderline: true,
                                    sx: {
                                        mt: 1,
                                        fontSize: '1rem',
                                        lineHeight: '1.5',
                                        fontFamily: 'inherit'
                                    }
                                }}
                            />
                        </Box>
                        <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block', px: 1 }}>
                            Notes are indexed and searchable within your event planning.
                        </Typography>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions sx={{ p: 3, justifyContent: 'space-between' }}>
                <Button onClick={onClose} sx={{ color: '#151269', fontWeight: 600 }}>
                    Cancel
                </Button>
                <Button
                    onClick={handleSave}
                    variant="contained"
                    sx={{
                        borderRadius: '10px',
                        px: 4,
                        bgcolor: '#151269',
                        boxShadow: '0 4px 14px 0 rgba(21, 18, 105, 0.39)',
                        '&:hover': {
                            bgcolor: '#352fcc',
                            boxShadow: '0 6px 20px rgba(53, 47, 204, 0.23)'
                        }
                    }}
                >
                    Save Notes
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ReceiptDialogEditNotes;